import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/pages/waitingroomStyles';

export default function Waitingroom() {
  const navigate = useNavigate();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Dain Leaders PMS</Text>
      <View style={styles.menuContainer}>
        <TouchableOpacity 
          style={styles.menuItem}
          onPress={() => navigate('/projectstatus')}
        >
          <Text style={styles.menuText}>Project Status</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}